import apiClient from "./axios";

export const getPackages = async (params = {}) => {
  const { data } = await apiClient.get("/packages", { params });
  return data;
};

export const getPackage = async (id) => {
  const { data } = await apiClient.get(`/packages/${id}`);
  return data;
};

export const createPackage = async (packageData) => {
  const { data } = await apiClient.post("/packages", packageData);
  return data;
};

export const editPackage = async ({ id, ...packageData }) => {
  const { data } = await apiClient.patch(`/packages/${id}`, packageData);
  return data;
};

export const deletePackage = async (id) => {
  const { data } = await apiClient.delete(`/packages/${id}`);
  return data;
};
